<template>
  <div id="usersWrapper">
    <my-title>Gebruikers</my-title>

    <div class="columns">
      <div class="column is-half">
        <div class="field">
          <div class="control">
            <input type="text" class="input" v-model="query" placeholder="Zoeken op naam of e-mail">
          </div>
        </div>
      </div>

      <div class="column is-half">
        <create-button
          caption="Nieuwe gebruiker"
          @click="edit({scopes: []})">
        </create-button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <table class="table is-striped is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Naam</th>
              <th class="is-narrow" v-for="scope in flattenedScopes" :key="scope.id"><p class="scope-label">{{ scope.name }}</p></th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="user in myUsers" :key="user.id">
              <td>
                {{ user.firstname }} {{ user.lastname }}
              </td >

              <td v-for="scope in flattenedScopes" :key="scope.id">
                <scope-check
                :userId="user.id"
                :selected="isGranted(user, scope.id)"
                :scope="scope"
                @toggle="setGrant"></scope-check>
              </td>

              <td class="is-narrow">
                <options-buttons @edit="edit(user)" @delete="remove(user.id)"></options-buttons>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <edit-modal :isActive="isActive">
      <user-edit
        v-if="user"
        :user="user"
        :isActive="isActive"
        @save="save"
        @close="toggle(false)">
      </user-edit>
    </edit-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyTitle from '@/components/modules/Title'
import UserEdit from '@/components/users/UserEdit'
import EditModal from '@/components/modules/EditModal'
import ScopeCheck from '@/components/scopes/ScopeCheck'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  components: {
    MyTitle,
    UserEdit,
    EditModal,
    ScopeCheck,
    CreateButton,
    OptionsButtons
  },
  data () {
    return {
      user: null,
      query: '',
      isActive: false,
      flattenedScopes: []
    }
  },
  computed: {
    ...mapGetters({
      users: 'users/users',
      scopes: 'scopes/scopes'
    }),
    myUsers () {
      return this.users.filter((user) => {
        const searchFields = `${user.firstname} ${user.lastname} ${user.email}`
        return searchFields.toLowerCase().includes(this.query.toLowerCase())
      })
    }
  },
  watch: {
    scopes () {
      if (this.scopes) {
        this.flatten(this.scopes)
      }
    }
  },
  created () {
    this.$store.dispatch('scopes/loadAll')
  },
  methods: {
    flatten (scopes) {
      scopes.forEach((scope) => {
        this.flattenedScopes.push({
          id: scope.id,
          name: scope.name,
          description: scope.description
        })

        this.flatten(scope.scopes)
      })
    },
    toggle (status) {
      this.isActive = status
    },
    edit (user) {
      this.user = user
      this.toggle(true)
    },
    save (params) {
      this.$store.dispatch('users/save', params)
    },
    remove (userId) {
      this.$store.dispatch('users/remove', userId)
    },
    isGranted (user, scopeId) {
      return user.scopes.includes(scopeId)
    },
    setGrant (payload) {
      this.$store.dispatch('users/setScope', {
        user_id: payload.userId,
        scope_id: payload.scopeId
      })
    }
  }
}
</script>

<style scoped>
  table {
    position: relative;
    top: 70px;
  }

  th {
    height: 100px;
    vertical-align: bottom;
  }

  .scope-label {
    transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
    -moz-transform:rotate(-30deg);
    width: 2rem;
  }
</style>
